<template>
  <div
    class="modal-mask"
    v-if="$store.getters.USERPROFILE['product-administration']"
  >
    <section class="modal reduced">
      <div class="content">
        <!-- HEAD Modify product -->
        <h1>{{$t('modifyProduct.title')}}</h1>
      </div>
      <hr>

      <div class="content">
        <div class="column">
          <label>{{$t('modifyProduct.productCode')}}</label>
          <div class="row">
            <input
              type="text"
              v-model="product['merchant-reference']"
            />
            <p class="tips">{{$t('modifyProduct.productCodeTips')}}</p>
          </div>
        </div>
        <div class="column">
          <label>{{$t('products.productName')}}</label>
          <div class="row">
            <input
              type="text"
              v-model="product['name']"
            />
            <p class="tips">{{$t('products.productNameTips')}}</p>
          </div>
        </div>
        <div class="column">
          <label>{{$t('modifyProduct.saleChannel')}}</label>
          <div class="row">
            <select v-model="product['channel-id']">
              <option
                v-for="channel in salesChannels"
                :key="channel.id"
                :value="channel.id"
              >
                {{channel['name']}} ({{channel['merchant-name']}})
              </option>
            </select>
            <p class="tips">
              {{$t('createProduct.selectOrCreateSalesChannel')}}
            </p>
          </div>
          <br>
          <a
            v-if="$store.getters.USERPROFILE['sales-channel-administration']"
            @click="show.modal = true"
          >{{$t('createProduct.newSalesChannel')}}</a>
          <AddSalesChannel
            v-if="show.modal"
            @close="show.modal = false"
            @get="getSalesChannels"
            @newchannel="selectNewChannel"
          ></AddSalesChannel>
          <div class="spacer"></div>
        </div>
      </div>
      <hr>
      <div class="content">
        <button @click="update">{{$t('button.modifyProduct')}}</button>
        <a @click="$emit('close')">{{$t('button.cancel')}}</a>
      </div>
    </section>
  </div>
</template>

<script>
import Products from "@/services/Products.js";
import SalesChannels from "@/services/SalesChannels.js";
import AddSalesChannel from "@/components/salesChannel/Add";
export default {
  components: { AddSalesChannel },
  props: ["parProductId"],
  data() {
    return {
      salesChannels: [],
      product: [],
      show: {
        modal: false
      }
    };
  },
  mounted() {
    this.getProduct(), this.getSalesChannels();
  },
  methods: {
    getSalesChannels() {
      SalesChannels.getSalesChannels().then(res => {
        this.salesChannels = res;
      });
    },
    getProduct() {
      Products.getProductById(this.parProductId).then(res => {
        SalesChannels.getById(res.data["channel-id"]).then(data => {
          res.data["channelName"] = data.data["name"];
          this.product = res.data;
        });
      });
    },
    selectNewChannel(data) {
      this.product["channel-id"] = data;
    },
    update() {
      Products.partialUpdate(this.product[`id`], {
        name: this.product["name"],
        "channel-id": this.product["channel-id"],
        "merchant-reference": this.product["merchant-reference"]
      }).then(res => {
        if (res.status == 204) {
          this.$emit("close");
          this.$emit("productupdated");
        }
      });
    }
  }
};
</script>